export enum SubscriptionType {
  TYPE_ONE_TIME = 'one_time',
  TYPE_RECURRING = 'recurring',
  TYPE_GROUPED = 'grouped',
  TYPE_FREE = 'free',
}
